import axios from 'axios';
import authHeader from "@/services/auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class DoctorService {
    fetchDoctorTypes(){
        return axios.get(`${API_URL}/doctortypes`);
    }
    fetchDoctorOfaPartcularType(doctortype_id){
        return axios.get(`${API_URL}/doctortypes/${doctortype_id}/doctors/approved`);
    }
    fetchPaginatedDoctorSbyDoctorType(doctortype_id,page_number){
        return axios.get(`${API_URL}/doctortypes/${doctortype_id}/doctors/approved?page=${page_number}`);
    }
    fetchDoctorSchedulebyDoctor(doctor_id){
        return axios.get(`${API_URL}/doctors/${doctor_id}/doctorschedules`);
    }

    setAppiontment(appiontment_form){
        return appiontment_form.post(`${API_URL}/doctorappointments`, {headers: authHeader()});
    }

}

export default new DoctorService();
